/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './dosage-guideline.reducer';

export const DosageGuidelineUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dosageGuidelineEntity = useAppSelector(state => state.dosageGuideline.entity);
  const loading = useAppSelector(state => state.dosageGuideline.loading);
  const updating = useAppSelector(state => state.dosageGuideline.updating);
  const updateSuccess = useAppSelector(state => state.dosageGuideline.updateSuccess);

  const handleClose = () => {
    navigate(`/dosage-guideline${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...dosageGuidelineEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...dosageGuidelineEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dosageGuideline.home.createOrEditLabel" data-cy="DosageGuidelineCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dosageGuideline.home.createOrEditLabel">Create or edit a DosageGuideline</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dosage-guideline-id"
                  label={translate('tinyMedicRestApp.dosageGuideline.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.name')}
                id="dosage-guideline-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.description')}
                id="dosage-guideline-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.dosageValue')}
                id="dosage-guideline-dosageValue"
                name="dosageValue"
                data-cy="dosageValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.dosageUnit')}
                id="dosage-guideline-dosageUnit"
                name="dosageUnit"
                data-cy="dosageUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.recommendedDosage')}
                id="dosage-guideline-recommendedDosage"
                name="recommendedDosage"
                data-cy="recommendedDosage"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.administrationRoute')}
                id="dosage-guideline-administrationRoute"
                name="administrationRoute"
                data-cy="administrationRoute"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.specialInstructions')}
                id="dosage-guideline-specialInstructions"
                name="specialInstructions"
                data-cy="specialInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.asNeeded')}
                id="dosage-guideline-asNeeded"
                name="asNeeded"
                data-cy="asNeeded"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.asNeededCondition')}
                id="dosage-guideline-asNeededCondition"
                name="asNeededCondition"
                data-cy="asNeededCondition"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.active')}
                id="dosage-guideline-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.cursor')}
                id="dosage-guideline-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.lastUpdated')}
                id="dosage-guideline-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.microSec')}
                id="dosage-guideline-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageGuideline.timestampEntry')}
                id="dosage-guideline-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dosage-guideline" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DosageGuidelineUpdate;
